<template>
  <v-list-group prepend-icon="mdi-table-cog" class="feature-group">
    <template v-slot:activator>
      <v-list-item-title>GPT management</v-list-item-title>
    </template>

    <v-list-item class="toggle-container">
      <v-list-item-action>
        <v-switch
          :input-value="active"
          @change="toggleActive"
          :loading="this.loading"
          inset
          color="blue"
        ></v-switch>
      </v-list-item-action>
      <v-list-item-title>асистент</v-list-item-title>
    </v-list-item>
    <v-list-item class="toggle-container">
      <v-list-item-action>
        <v-switch
          :disabled="!active"
          :input-value="autoReplyActive"
          @change="toggleAutoReplyActive"
          :loading="this.loading"
          inset
          color="blue"
        ></v-switch>
      </v-list-item-action>
      <v-list-item-title>автоматический ответ</v-list-item-title>
    </v-list-item>
    <v-list-item class="toggle-container">
      <v-list-item-action>
        <v-switch
          :disabled="!active || !autoReplyActive"
          :input-value="offHoursAutoReplyActive"
          @change="toggleOffHoursAutoReplyActive"
          :loading="this.loading"
          inset
          color="blue"
        ></v-switch>
      </v-list-item-action>
      <v-list-item-title>автоответ в нерабочее время</v-list-item-title>
    </v-list-item>
    <v-list-item class="delay-container">
      <v-text-field
        :disabled="!active"
        type="number"
        v-model.number="localDelay"
      />
      <v-btn :disabled="!active" @click="setDelay">обновить задержку</v-btn>
    </v-list-item>
    <v-list-item class="delay-container">
      <v-text-field
        :disabled="!active"
        type="number"
        v-model.number="localAiCaseDelay"
      />
      <v-btn :disabled="!active" @click="setAiCaseDelay">
        обновить задержку AI case
      </v-btn>
    </v-list-item>
    <v-list-item class="toggle-container">
      <v-list-item-action>
        <v-switch
          :input-value="aiCaseEnabled"
          @change="setAiCaseEnabled"
          :loading="aiCaseLoading"
          inset
          color="blue"
        ></v-switch>
      </v-list-item-action>
      <v-list-item-title>AI case</v-list-item-title>
    </v-list-item>
  </v-list-group>
</template>
<script>
export default {
  name: 'GptFeaturesMenu',

  data() {
    return {
      loading: false,
      localDelay: this.$store.state.gpt.delay,
      localAiCaseDelay: this.$store.state.gpt.aiCaseDelay,
    };
  },

  created() {
    this.$store.dispatch('gpt/getAiCaseConfig');
  },

  watch: {
    delay: {
      immediate: true,
      handler(newDelay) {
        this.localDelay = newDelay;
      },
    },
    aiCaseDelay: {
      immediate: true,
      handler(newAiCaseDelay) {
        this.localAiCaseDelay = newAiCaseDelay;
      },
    },
  },

  computed: {
    active() {
      return this.$store.state.gpt.active;
    },
    autoReplyActive() {
      return this.$store.state.gpt.autoReplyActive;
    },
    offHoursAutoReplyActive() {
      return this.$store.state.gpt.offHoursAutoReplyActive;
    },
    delay() {
      return this.$store.state.gpt.delay;
    },
    aiCaseDelay() {
      return this.$store.state.gpt.aiCaseDelay;
    },
    aiCaseEnabled() {
      return this.$store.state.gpt.aiCaseEnabled;
    },
    aiCaseLoading() {
      return this.$store.state.gpt.aiCaseLoading;
    },
  },

  methods: {
    async toggleActive() {
      try {
        this.loading = true;
        await this.$store.dispatch('gpt/toggleActive');
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async toggleAutoReplyActive() {
      try {
        this.loading = true;
        await this.$store.dispatch('gpt/toggleAutoReplyActive');
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async toggleOffHoursAutoReplyActive() {
      try {
        this.loading = true;
        await this.$store.dispatch('gpt/toggleOffHoursAutoReplyActive');
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async setDelay() {
      try {
        this.loading = true;
        await this.$store.dispatch('gpt/setDelay', { delay: this.localDelay });
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async setAiCaseDelay() {
      try {
        this.loading = true;
        await this.$store.dispatch('gpt/setAiCaseDelay', {
          aiCaseDelay: this.localAiCaseDelay,
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    setAiCaseEnabled(value) {
      this.$store.dispatch('gpt/setAiCaseConfig', value);
    },
  },
};
</script>
<style lang="scss">
.feature-group {
  .toggle-container {
    margin-left: 20px;
  }

  .delay-container {
    margin-left: 20px;
    gap: 20px;

    .v-input {
      max-width: 50px;
    }
  }
}
</style>
